import { responsive_breakpoints } from "../constant/Responsive";

/** @type {import('@mantine/core').MantineThemeOverride} */
export const appTheme = {
  breakpoints: responsive_breakpoints,
  primaryColor: "orange",
  colors: {
    orange: [
      "#faf6ed",
      "#f5ecd4",
      "#ead9a8",
      "#dcc270",
      "#caa83a",
      "#b8960c",
      "#a68508",
      "#8f7207",
      "#735b05",
      "#524004",
    ],
    gray: [
      "#f8f6f3",
      "#f0ede8",
      "#e3dfd8",
      "#c9c4bc",
      "#9c968d",
      "#6b665f",
      "#4d4944",
      "#35322e",
      "#252320",
      "#141210",
    ],
  },
  fontFamily: '"Noto Sans TC", "Outfit", sans-serif',
  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
  },
  headings: {
    fontFamily: '"Noto Serif TC", serif',
    fontWeight: "600",
    sizes: {
      h1: { fontSize: "clamp(1.85rem, 4.5vw, 2.75rem)", letterSpacing: "0.02em" },
      h2: { fontSize: "clamp(1.35rem, 2.5vw, 1.65rem)", letterSpacing: "0.03em" },
      h3: { fontSize: "clamp(1.15rem, 1.5vw, 1.3rem)", letterSpacing: "0.02em" },
    },
  },
  radius: {
    xs: "4px",
    sm: "6px",
    md: "10px",
    lg: "14px",
    xl: "18px",
  },
  shadows: {
    xs: "0 1px 3px rgba(0, 0, 0, 0.04)",
    sm: "0 4px 12px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04)",
    md: "0 8px 24px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04)",
    lg: "0 16px 48px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.05)",
  },
  defaultRadius: "lg",
  components: {
    Button: {
      defaultProps: {
        radius: "lg",
      },
    },
    Card: {
      defaultProps: {
        radius: "lg",
        shadow: "xs",
      },
    },
    Container: {
      defaultProps: {
        sizes: {
          xs: 540,
          sm: 720,
          md: 960,
          lg: 1140,
          xl: 1260,
        },
      },
    },
  },
};
